import React, { FC, useMemo } from "react";
import { Banner } from "interfaces/front/business";

const ProjectBanner: FC<{ banner: Banner }> = ({ banner }) => {
  const target = useMemo(() => (banner.link.startsWith(process.env.API_CF_BASE_URL as string) ? undefined : "_blank"), []);
  return (
    <a href={banner.link} target={target} rel="noreferrer">
      <img src={banner.image} alt="" width="300" height="63" loading="lazy" />
    </a>
  );
};
export default ProjectBanner;
